<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        tipopicdescricao: '',
        tipopictipocontrole: '',
        tipopictipoaprovacao: '',
        usuarioid: '',
        tipousuarioid: '',
        tipopicreserva: false,
        tipopiccliente: false,
        tipopicrede: false,
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      isLoading: false,
      dataFromApiTabelaPreco: '',
      dataFromApiTipoUsuario: '',
      dataFromApiUsuario: '',
      optionsTipoControle: [
        {
          label: 'Controla Saldo',
          value: 'CS',
        },
        {
          label: 'Não Controla Saldo',
          value: 'NCS',
        },
        {
          label: 'Quantidade Exata',
          value: 'QE',
        },
      ],
      optionsTipoAprovacao: [
        {
          label: 'Alçada',
          value: 'AL',
        },
        {
          label: 'Tipo Usuario',
          value: 'TU',
        },
        {
          label: 'Usuario',
          value: 'U',
        },
      ],
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTabelaPreco();
      this.fetchDataFromUsuarios();
      this.fetchDataFromTipoUsuario();
    },
    async validateForm() {
      if (this.dataForm.tipopicid === '' || this.dataForm.tipopicdescricao === '' || this.dataForm.tipopictipocontrole === '' || this.dataForm.tipopictipoaprovacao === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário incompleto',
            text: 'Selecione todos os valores obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }
      if (this.dataForm.tipopicid && this.dataForm.tipopicdescricao && this.dataForm.tipopictipocontrole && this.dataForm.tipopictipoaprovacao) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
        this.dataForm = {
          tipopicid: '',
          tipopicdescricao: '',
          tipopictipocontrole: '',
          tipopictipoaprovacao: '',
          usuarioid: '',
          tipousuarioid: '',
          tipopicreserva: false,
          tipopiccliente: false,
          tipopicrede: false,
          tabelapreco: false,
          tabprecoid: '',
        };
      }
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
    async fetchDataFromTabelaPreco() {
      this.isLoading = true;
      try {
        const response = await axios.get('/tabela-preco');
        this.dataFromApiTabelaPreco = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchDataFromUsuarios() {
      this.isLoading = true;
      try {
        const response = await axios.get('/usuarios/findAll');
        this.dataFromApiUsuario = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchDataFromTipoUsuario() {
      this.isLoading = true;
      try {
        const response = await axios.get('/perfilAcesso/findAll');
        this.dataFromApiTipoUsuario = response.data.data;
        this.dataFromApiTipoUsuario = this.dataFromApiTipoUsuario.filter((tipoUsuario) => tipoUsuario.perfil_acesso_nome !== 'AdminDKP');
        console.log(this.dataFromApiUsuario);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.tipopicid === '' || dataForm.tipopicdescricao === '' || dataForm.tipopictipocontrole === '' || dataForm.tipopictipoaprovacao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Código"
                label-for="tipopicid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipopicid"
                    id="tipopicid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o código"
                    :disabled="dataForm.isDefault"
                    maxlength="10"
                    @input="toUpperCase"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Descrição"
                label-for="tipopicdescricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipopicdescricao"
                    id="tipopicdescricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Controle"
                label-for="tipopictipocontrole"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipopictipocontrole"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipopictipocontrole"
                    id="tipopictipocontrole"
                    :state="errors.length > 0 ? false : null"
                    text-field="label"
                    value-field="value"
                    :options="optionsTipoControle"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Aprovação"
                label-for="tipopictipoaprovacao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipopictipoaprovacao"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipopictipoaprovacao"
                    id="tipopictipoaprovacao"
                    :state="errors.length > 0 ? false : null"
                    text-field="label"
                    value-field="value"
                    :options="optionsTipoAprovacao"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Usuario"
                label-for="usuarioid"
                v-if="dataForm.tipopictipoaprovacao === 'U'"
            >
              <validation-provider
                  #default="{ errors }"
                  name="usuarioid"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.usuarioid"
                    id="usuarioid"
                    :state="errors.length > 0 ? false : null"
                    text-field="usuario_nome"
                    value-field="usuarioid"
                    :options="dataFromApiUsuario"
                    :disabled="dataForm.isDefault || isLoading"
                />
                <small v-if="isLoading">
                  Carregando...
                </small>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
              v-if="dataForm.tipopictipoaprovacao === 'TU'"
          >
            <b-form-group
                label="Tipo Usuario"
                label-for="tipousuarioid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipousuarioid"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipousuarioid"
                    id="tipousuarioid"
                    :state="errors.length > 0 ? false : null"
                    text-field="perfil_acesso_nome"
                    value-field="id"
                    :options="dataFromApiTipoUsuario"
                    :disabled="dataForm.isDefault || isLoading"
                />
                <small v-if="isLoading">
                  Carregando...
                </small>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="3"
              class="mb-1"
          >
            <b-form-group
                label="Reserva"
                label-for="tipopicreserva"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipopicreserva"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.tipopicreserva"
                    id="tipopicreserva"
                    :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="3"
              class="mb-1"
          >
            <b-form-group
                label="Cliente"
                label-for="tipopiccliente"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipopiccliente"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.tipopiccliente"
                    id="tipopiccliente"
                    :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="3"
              class="mb-1"
          >
            <b-form-group
                label="Rede"
                label-for="tipopicrede"
            >
              <validation-provider
                  #default="{ errors }"
                  name="tipopicrede"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.tipopicrede"
                    id="tipopicrede"
                    :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
